import type { DistanceUnit } from '@coffee-to-go/common';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SettingsState {
  radius: number; // in km (always stored in km internally)
  unit: DistanceUnit;
  categoryFilter: 'vertical' | 'category';
}

interface SettingsStore {
  settings: SettingsState;

  // Actions
  actions: {
    setSettings: (settings: SettingsState) => void;
    reset: () => void;
  };
}

const defaultSettings: SettingsState = {
  radius: 10, // 10km default
  unit: 'km',
  categoryFilter: 'vertical',
};

const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      // Initial state
      settings: defaultSettings,

      actions: {
        // Settings actions
        setSettings: (settings) => set({ settings }),

        // Utility actions
        reset: () =>
          set({
            settings: defaultSettings,
          }),
      },
    }),
    {
      name: 'settings-store',
      partialize: (state) => ({
        settings: state.settings,
      }),
    },
  ),
);

// Actions
export const useSettingsStoreActions = () => useSettingsStore((state) => state.actions);

// Selectors
export const useSettings = () => useSettingsStore((state) => state.settings);

export default useSettingsStore;
